export default __webpack_public_path__ + "static/media/bede_black.528c2b5e.svg";